import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  de: {
    translation: {
      // Navigation
      nav: {
        locations: 'Standorte',
        pricing: 'Preise',
        howItWorks: 'So funktioniert\'s',
        contact: 'Kontakt',
        admin: 'Admin',
        findLocation: 'Standort finden'
      },
      // Homepage
      hero: {
        tagline: 'Vom ZüriOberland fürs ZüriOberland',
        title: 'Sichtbare Werbung an',
        titleHighlight: 'Top-Standorten',
        subtitle: 'Mieten Sie mobile Werbeflächen an stark frequentierten Standorten im Zürcher Oberland. Einfach buchen, sofort sichtbar.',
        cta: 'Standort finden',
        secondaryCta: 'So funktioniert\'s'
      },
      features: {
        title: 'Warum ZO Werbefläche?',
        visibility: {
          title: 'Hohe Sichtbarkeit',
          description: 'Strategisch platzierte Anhänger an Hauptverkehrsachsen'
        },
        flexibility: {
          title: 'Flexible Laufzeiten',
          description: 'Von einer Woche bis mehrere Monate - Sie entscheiden'
        },
        booking: {
          title: 'Einfach buchen',
          description: 'Online verfügbarkeit prüfen und sofort buchen'
        },
        local: {
          title: 'Lokal & persönlich',
          description: 'Ihr Partner aus dem Zürcher Oberland'
        }
      },
      howItWorks: {
        title: 'So einfach geht\'s',
        step1: {
          title: 'Standort wählen',
          description: 'Wählen Sie Ihren Wunschstandort auf der Karte'
        },
        step2: {
          title: 'Zeitraum festlegen',
          description: 'Bestimmen Sie Start- und Enddatum Ihrer Kampagne'
        },
        step3: {
          title: 'Buchen & Werben',
          description: 'Bezahlen Sie sicher online und starten Sie Ihre Werbung'
        }
      },
      // Locations
      locations: {
        title: 'Unsere Standorte',
        subtitle: 'Finden Sie den perfekten Standort für Ihre Werbung',
        filterAll: 'Alle',
        mapView: 'Karte',
        listView: 'Liste',
        perWeek: '/Woche',
        perMonth: '/Monat',
        vehiclesPerDay: 'Fahrzeuge/Tag',
        available: 'Verfügbar',
        booked: 'Gebucht',
        details: 'Details ansehen',
        bookNow: 'Jetzt buchen',
        noLocations: 'Keine Standorte gefunden'
      },
      // Location Detail
      locationDetail: {
        backToLocations: 'Zurück zu Standorten',
        trailerInfo: 'Anhänger-Info',
        size: 'Grösse',
        lighting: 'Beleuchtung',
        mobile: 'Mobil',
        yes: 'Ja',
        no: 'Nein',
        pricing: 'Preise',
        weekly: 'Wochenpreis',
        monthly: 'Monatspreis',
        availability: 'Verfügbarkeit',
        selectDates: 'Daten auswählen',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        checkAvailability: 'Verfügbarkeit prüfen',
        notAvailable: 'Ausgewählte Daten nicht verfügbar',
        totalPrice: 'Gesamtpreis',
        proceedToBooking: 'Zur Buchung'
      },
      // Booking/Checkout
      checkout: {
        title: 'Buchung abschliessen',
        yourBooking: 'Ihre Buchung',
        location: 'Standort',
        period: 'Zeitraum',
        duration: 'Dauer',
        days: 'Tage',
        weeks: 'Wochen',
        price: 'Preis',
        total: 'Gesamt',
        yourDetails: 'Ihre Angaben',
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        notes: 'Anmerkungen',
        notesPlaceholder: 'Besondere Wünsche oder Anmerkungen...',
        uploadDesign: 'Design hochladen (optional)',
        uploadHint: 'Laden Sie Ihr Werbedesign hoch (PDF, JPG, PNG)',
        payNow: 'Jetzt bezahlen',
        processing: 'Wird verarbeitet...',
        termsAgree: 'Mit der Buchung akzeptieren Sie unsere',
        terms: 'AGB',
        and: 'und',
        privacy: 'Datenschutzerklärung'
      },
      // Payment
      payment: {
        success: {
          title: 'Zahlung erfolgreich!',
          message: 'Vielen Dank für Ihre Buchung.',
          details: 'Sie erhalten in Kürze eine Bestätigung per E-Mail.',
          bookingId: 'Buchungs-ID',
          backHome: 'Zurück zur Startseite'
        },
        cancel: {
          title: 'Zahlung abgebrochen',
          message: 'Die Zahlung wurde abgebrochen.',
          tryAgain: 'Erneut versuchen',
          backHome: 'Zurück zur Startseite'
        },
        processing: 'Zahlung wird verarbeitet...'
      },
      // Footer
      footer: {
        description: 'Ihr Partner für mobile Werbeflächen im Zürcher Oberland.',
        quickLinks: 'Schnelllinks',
        legal: 'Rechtliches',
        contact: 'Kontakt',
        terms: 'AGB',
        privacy: 'Datenschutz',
        imprint: 'Impressum',
        copyright: '© 2024 ZO Werbeflächen. Alle Rechte vorbehalten.'
      },
      // Common
      common: {
        loading: 'Laden...',
        error: 'Fehler',
        save: 'Speichern',
        cancel: 'Abbrechen',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        create: 'Erstellen',
        search: 'Suchen',
        filter: 'Filtern',
        noResults: 'Keine Ergebnisse',
        currency: 'CHF'
      },
      // Admin
      admin: {
        dashboard: 'Dashboard',
        trailers: 'Anhänger',
        locations: 'Standorte',
        bookings: 'Buchungen',
        settings: 'Einstellungen',
        stats: {
          totalBookings: 'Buchungen gesamt',
          paidBookings: 'Bezahlte Buchungen',
          pendingBookings: 'Ausstehende Buchungen',
          totalRevenue: 'Umsatz gesamt',
          totalTrailers: 'Anhänger',
          totalLocations: 'Standorte'
        },
        recentBookings: 'Letzte Buchungen',
        createTrailer: 'Anhänger erstellen',
        createLocation: 'Standort erstellen',
        editTrailer: 'Anhänger bearbeiten',
        editLocation: 'Standort bearbeiten',
        trailerName: 'Name',
        trailerDescription: 'Beschreibung',
        trailerSize: 'Grösse (m²)',
        trailerLighting: 'Beleuchtung',
        trailerMobile: 'Mobil',
        locationName: 'Name',
        locationAddress: 'Adresse',
        locationCoordinates: 'Koordinaten',
        locationTraffic: 'Verkehrsfrequenz',
        locationPriceWeek: 'Preis/Woche (CHF)',
        locationPriceMonth: 'Preis/Monat (CHF)',
        assignTrailer: 'Anhänger zuweisen',
        noTrailerAssigned: 'Kein Anhänger zugewiesen',
        googleMapsKey: 'Google Maps API Key',
        companyName: 'Firmenname',
        companyEmail: 'E-Mail',
        companyPhone: 'Telefon',
        companyAddress: 'Adresse',
        saveSettings: 'Einstellungen speichern'
      }
    }
  },
  en: {
    translation: {
      nav: {
        locations: 'Locations',
        pricing: 'Pricing',
        howItWorks: 'How it works',
        contact: 'Contact',
        admin: 'Admin',
        findLocation: 'Find Location'
      },
      hero: {
        tagline: 'From ZüriOberland for ZüriOberland',
        title: 'Visible advertising at',
        titleHighlight: 'prime locations',
        subtitle: 'Rent mobile advertising spaces at high-traffic locations in Zürich Oberland. Easy to book, instantly visible.',
        cta: 'Find Location',
        secondaryCta: 'How it works'
      },
      features: {
        title: 'Why ZO Advertising Spaces?',
        visibility: {
          title: 'High Visibility',
          description: 'Strategically placed trailers on main traffic routes'
        },
        flexibility: {
          title: 'Flexible Duration',
          description: 'From one week to several months - you decide'
        },
        booking: {
          title: 'Easy Booking',
          description: 'Check availability online and book instantly'
        },
        local: {
          title: 'Local & Personal',
          description: 'Your partner from Zürich Oberland'
        }
      },
      howItWorks: {
        title: 'How it works',
        step1: {
          title: 'Choose Location',
          description: 'Select your desired location on the map'
        },
        step2: {
          title: 'Set Period',
          description: 'Determine the start and end date of your campaign'
        },
        step3: {
          title: 'Book & Advertise',
          description: 'Pay securely online and start your advertising'
        }
      },
      locations: {
        title: 'Our Locations',
        subtitle: 'Find the perfect location for your advertising',
        filterAll: 'All',
        mapView: 'Map',
        listView: 'List',
        perWeek: '/week',
        perMonth: '/month',
        vehiclesPerDay: 'vehicles/day',
        available: 'Available',
        booked: 'Booked',
        details: 'View Details',
        bookNow: 'Book Now',
        noLocations: 'No locations found'
      },
      locationDetail: {
        backToLocations: 'Back to Locations',
        trailerInfo: 'Trailer Info',
        size: 'Size',
        lighting: 'Lighting',
        mobile: 'Mobile',
        yes: 'Yes',
        no: 'No',
        pricing: 'Pricing',
        weekly: 'Weekly price',
        monthly: 'Monthly price',
        availability: 'Availability',
        selectDates: 'Select dates',
        startDate: 'Start date',
        endDate: 'End date',
        checkAvailability: 'Check availability',
        notAvailable: 'Selected dates not available',
        totalPrice: 'Total price',
        proceedToBooking: 'Proceed to Booking'
      },
      checkout: {
        title: 'Complete Booking',
        yourBooking: 'Your Booking',
        location: 'Location',
        period: 'Period',
        duration: 'Duration',
        days: 'days',
        weeks: 'weeks',
        price: 'Price',
        total: 'Total',
        yourDetails: 'Your Details',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        notes: 'Notes',
        notesPlaceholder: 'Special requests or notes...',
        uploadDesign: 'Upload Design (optional)',
        uploadHint: 'Upload your advertising design (PDF, JPG, PNG)',
        payNow: 'Pay Now',
        processing: 'Processing...',
        termsAgree: 'By booking you accept our',
        terms: 'Terms',
        and: 'and',
        privacy: 'Privacy Policy'
      },
      payment: {
        success: {
          title: 'Payment Successful!',
          message: 'Thank you for your booking.',
          details: 'You will receive a confirmation email shortly.',
          bookingId: 'Booking ID',
          backHome: 'Back to Homepage'
        },
        cancel: {
          title: 'Payment Cancelled',
          message: 'The payment was cancelled.',
          tryAgain: 'Try Again',
          backHome: 'Back to Homepage'
        },
        processing: 'Processing payment...'
      },
      footer: {
        description: 'Your partner for mobile advertising spaces in Zürich Oberland.',
        quickLinks: 'Quick Links',
        legal: 'Legal',
        contact: 'Contact',
        terms: 'Terms',
        privacy: 'Privacy',
        imprint: 'Imprint',
        copyright: '© 2024 ZO Werbeflächen. All rights reserved.'
      },
      common: {
        loading: 'Loading...',
        error: 'Error',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        create: 'Create',
        search: 'Search',
        filter: 'Filter',
        noResults: 'No results',
        currency: 'CHF'
      },
      admin: {
        dashboard: 'Dashboard',
        trailers: 'Trailers',
        locations: 'Locations',
        bookings: 'Bookings',
        settings: 'Settings',
        stats: {
          totalBookings: 'Total Bookings',
          paidBookings: 'Paid Bookings',
          pendingBookings: 'Pending Bookings',
          totalRevenue: 'Total Revenue',
          totalTrailers: 'Trailers',
          totalLocations: 'Locations'
        },
        recentBookings: 'Recent Bookings',
        createTrailer: 'Create Trailer',
        createLocation: 'Create Location',
        editTrailer: 'Edit Trailer',
        editLocation: 'Edit Location',
        trailerName: 'Name',
        trailerDescription: 'Description',
        trailerSize: 'Size (m²)',
        trailerLighting: 'Lighting',
        trailerMobile: 'Mobile',
        locationName: 'Name',
        locationAddress: 'Address',
        locationCoordinates: 'Coordinates',
        locationTraffic: 'Traffic Frequency',
        locationPriceWeek: 'Price/Week (CHF)',
        locationPriceMonth: 'Price/Month (CHF)',
        assignTrailer: 'Assign Trailer',
        noTrailerAssigned: 'No trailer assigned',
        googleMapsKey: 'Google Maps API Key',
        companyName: 'Company Name',
        companyEmail: 'Email',
        companyPhone: 'Phone',
        companyAddress: 'Address',
        saveSettings: 'Save Settings'
      }
    }
  },
  fr: {
    translation: {
      nav: {
        locations: 'Emplacements',
        pricing: 'Tarifs',
        howItWorks: 'Comment ça marche',
        contact: 'Contact',
        admin: 'Admin',
        findLocation: 'Trouver un emplacement'
      },
      hero: {
        tagline: 'De ZüriOberland pour ZüriOberland',
        title: 'Publicité visible aux',
        titleHighlight: 'meilleurs emplacements',
        subtitle: 'Louez des espaces publicitaires mobiles dans des zones à fort trafic à Zürich Oberland. Réservation simple, visibilité immédiate.',
        cta: 'Trouver un emplacement',
        secondaryCta: 'Comment ça marche'
      },
      common: {
        loading: 'Chargement...',
        error: 'Erreur',
        save: 'Enregistrer',
        cancel: 'Annuler',
        currency: 'CHF'
      }
    }
  },
  it: {
    translation: {
      nav: {
        locations: 'Posizioni',
        pricing: 'Prezzi',
        howItWorks: 'Come funziona',
        contact: 'Contatto',
        admin: 'Admin',
        findLocation: 'Trova posizione'
      },
      hero: {
        tagline: 'Da ZüriOberland per ZüriOberland',
        title: 'Pubblicità visibile nelle',
        titleHighlight: 'posizioni migliori',
        subtitle: 'Affitta spazi pubblicitari mobili in zone ad alto traffico a Zürich Oberland. Facile da prenotare, subito visibile.',
        cta: 'Trova posizione',
        secondaryCta: 'Come funziona'
      },
      common: {
        loading: 'Caricamento...',
        error: 'Errore',
        save: 'Salva',
        cancel: 'Annulla',
        currency: 'CHF'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de',
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
